// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForOrganizationsPage } from '@streaming-projects/links';
import { getDeleteWithWarningHeaderAndBody } from '@src/common-utils/utils';
import { useDeleteFlinkPoolResourceMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPFlinkPoolResourceDeleteWarningModal = ({
  isOpen,
  onClose,
  flinkPoolName,
  flinkPoolId,
  version = null,
}) => {
  const [deleteFlinkPoolResource] = useDeleteFlinkPoolResourceMutation();
  const { orgId } = useParams();
  const { push } = useHistory();
  const { header, headerBody } = getDeleteWithWarningHeaderAndBody('Flink Resource', flinkPoolName);

  const onClickHandlerForOK = async () => {
    const { error } = await deleteFlinkPoolResource({
      flinkPoolResourceId: flinkPoolId,
      orgId: orgId,
      payload: {
        version: version,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Flink Pool Resource delete was successful!');
      push(getLinkForOrganizationsPage(orgId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
